import * as DataUtil from '../util/DataUtil'

const dataPath = '/data'
const indexesPath = `${dataPath}/indexes`

export const update=(cb,cbe)=>{
  const fileName = `${DataUtil.UPDATED}${DataUtil.DOT_JSON}`
  const filePath = `${indexesPath}/${fileName}`
  DataUtil.fetchText(filePath, data=>{
    if (typeof(cb)==='function') {
      cb(data)
    }
  }, e=>{
    if (typeof(cbe)==='function') {
      cbe(e)
    }
  })
}

export const aggregates=(cb,cbe)=>{
  const fileName = '_.json'
  const filePath = `${indexesPath}/${fileName}`
  DataUtil.fetchArray(filePath, data=>{
    if (typeof(cb)==='function') {
      cb(data)
    }
  }, e=>{
    if (typeof(cbe)==='function') {
      cbe(e)
    }
  })
}

export const contents=(type,cb,cbe)=>{
  if (typeof(type)==='string'&&type.length>0) {
    const fileName = `${type}.json`
    const filePath = `${indexesPath}/${fileName}`
    DataUtil.fetchArray(filePath, data=>{
      if (typeof(cb)==='function') {
        cb(data)
      }
    }, e=>{
      if (typeof(cbe)==='function') {
        cbe(e)
      }
    })
  } else {
    if (typeof(cbe)==='function') {
      cbe('Invalid type')
    }
  }
}

export const queue=(name,page,cb,cbe)=>{
  if (typeof(name)==='string'&&name.length>0) {
    let fileName = `q_${name}.json`
    if (typeof(page)==='number'&&page>=0) {
      fileName = `q_${name}_${page}.json`
    }
    const filePath = `${indexesPath}/${fileName}`
    DataUtil.fetchArray(filePath, data=>{
      if (typeof(cb)==='function') {
        cb(data)
      }
    }, e=>{
      if (typeof(cbe)==='function') {
        cbe(e)
      }
    })
  } else {
    if (typeof(cbe)==='function') {
      cbe('Invalid name')
    }
  }
}

export const slugs=(type,cb,cbe)=>{
  if (typeof(type)==='string'&&type.length>0) {
    const fileName = `${type}__slug.json`
    const filePath = `${indexesPath}/${fileName}`
    DataUtil.fetchArray(filePath, data=>{
      if (typeof(cb)==='function') {
        cb(data)
      }
    }, e=>{
      if (typeof(cbe)==='function') {
        cbe(e)
      }
    })
  } else {
    if (typeof(cbe)==='function') {
      cbe('Invalid type')
    }
  }
}

export const content=(type,id,cb,cbe)=>{
  if (typeof(type)==='string'&&type.length>0) {
    if (typeof(id)==='string'&&id.length>0) {
      const contentsPath = `${dataPath}/contents/${type}`
      const fileName = `${id}.json`
      const filePath = `${contentsPath}/${fileName}`
      DataUtil.fetchObject(filePath, data=>{
        if (typeof(cb)==='function') {
          cb(data)
        }
      }, e=>{
        if (typeof(cbe)==='function') {
          cbe(e)
        }
      })
    } else {
      if (typeof(cbe)==='function') {
        cbe('Invalid id')
      }
    }
  } else {
    if (typeof(cbe)==='function') {
      cbe('Invalid type')
    }
  }
}

export const text=(name,cb,cbe)=>{
  if (typeof(name)==='string'&&name.length>0) {
    const fileName = `${name}.json`
    const filePath = `${indexesPath}/${fileName}`
    DataUtil.fetchText(filePath,text=>{
      if (typeof(text)==='string') {
        if (typeof(cb)==='function') {
          cb(text)
        }
      }
    }, e=>{
      if (typeof(cbe)==='function') {
        cbe(e)
      }
    })
  } else {
    if (typeof(cbe)==='function') {
      cbe('Invalid name')
    }
  }
}
